@if (this.client$ | async; as client) {
  <div [formGroup]="formGroup">
    @if ((this.administrations$ | async)?.length) {
      <p>
        Bij de klantinstellingen van {{ client.name }} maak je een koppeling met een SnelStart
        administratie of een externe administratie.<br />
        Hieronder kun je er voor kiezen de gegevens uit de administratie te gebruiken bij de jaarrapportage.<br />
        Maak je na het inlezen wijzigingen in de administratie, dan worden deze NIET automatisch opnieuw ingelezen in de
        jaarrapportage.
      </p>
      <div class="row align-items-center">
        <div class="col-xl-3 col-lg-4 col-md-6">
          <snelstart-ui-select-form-control formControlName="administrationId"
                                            id="administrationId"
                                            label="Selecteer administratie"
                                            [options]="(this.administrationOptions$ | async) ?? []"
                                            class="me-1 custom-input-250">
          </snelstart-ui-select-form-control>
        </div>
        @if (this.selectedAdministration$ | async) {
          @if (this.identityProviderStatus$ | async; as identityProviderStatus) {
            @if (!identityProviderStatus.authenticated) {
              <div class="col-xl-3 col-lg-4 col-md-6 pt-1">
                <span>U bent niet aangemeld bij {{ (this.identityProviderStatus$ | async)?.name }}</span>
              </div>
            }
          }
        }
      </div>
      @if (this.selectedAdministration$ | async; as selectedAdministration) {
        <div class="row">
          @if (!selectedAdministration.providerId) {
            <div class="col-xl-3 col-lg-4 col-md-6">
              <snelstart-ui-button [config]="this.importSnelStartBalanceButtonConfiguration"
                                   type="primary"
                                   class="me-1 pt-1 custom-input-250">
                Administratie inlezen
              </snelstart-ui-button>
            </div>
          } @else if ((this.identityProviderStatus$ | async)?.authenticated) {
            <div class="col-xl-3 col-lg-4 col-md-6">
              <snelstart-ui-button [config]="this.importBalanceProviderBalanceButtonConfiguration"
                                   [disabled]="!(this.identityProviderStatus$ | async)?.authenticated"
                                   type="primary"
                                   class="me-1 pt-1 custom-input-250">
                Administratie inlezen
              </snelstart-ui-button>
            </div>
          }
        </div>
      }
    } @else {
      <p>Er zijn op dit moment geen administraties gekoppeld aan {{ (this.client$ | async)?.name }}.</p>
      <p>Bij de klantinstellingen is het mogelijk administraties te koppelen.</p>
    }
  </div>
}
